import React, { useRef } from "react";
import { TextInput } from "@mantine/core";
import { SummaryLocation } from "@/components/bnp-icons";
import { Control, Controller } from "react-hook-form";
import { useLoadScript, Autocomplete } from "@react-google-maps/api";

const libraries: "places"[] = ["places"];

interface PlacesAutocompleteProps {
  control: Control<any>;
  errors: any;
  country?: string;
}

const PlacesAutocomplete: React.FC<PlacesAutocompleteProps> = ({
  control,
  errors,
  country = "NG",
}) => {
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY as string,
    libraries,
  });

  const autocompleteOptions = {
    componentRestrictions: { country: country },
    fields: ["address_components", "formatted_address"],
    types: ["address"],
  };

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading...</div>;

  return (
    <Controller
      name="business_address"
      control={control}
      rules={{
        required: "Business Address is required",
      }}
      render={({ field: { onChange, onBlur, value } }) => (
        <Autocomplete
          options={autocompleteOptions}
          onLoad={(autocomplete) => {
            autocompleteRef.current = autocomplete;
          }}
          onPlaceChanged={() => {
            const place = autocompleteRef.current?.getPlace();
            if (place?.formatted_address) {
              onChange(place.formatted_address);
            }
          }}
        >
          <TextInput
            type="text"
            name="business_address"
            label="Business Address"
            value={value || ""}
            withAsterisk
            placeholder="Enter your business address"
            leftSection={<SummaryLocation />}
            size="md"
            radius="md"
            className="w-[100%] h-[52px] mb-8"
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBlur}
            error={errors.business_address?.message}
          />
        </Autocomplete>
      )}
    />
  );
};

export default PlacesAutocomplete;
